import {
  ClipboardText, Compass, Wrench, Buildings, Gear, HeartStraight,
  ChatCircleText, UserFocus, Ruler, ChartLineUp, Handshake, MagnifyingGlass,
  PencilRuler, Hammer, SealCheck,
} from "@phosphor-icons/react";

export const IMG = {
  hero: "https://images.unsplash.com/photo-1551038247-3d9af20df552?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBoZWFsdGhjYXJlJTIwYnVpbGRpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgzOTMxNTc3fDA&ixlib=rb-4.1.0&q=85",
  apartment: "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM5MzE1Nzd8MA&ixlib=rb-4.1.0&q=85",
  construction: "https://images.unsplash.com/photo-1599707254554-027aeb4deacd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwZW5naW5lZXJpbmd8ZW58MHx8fHwxNzgzOTMxNTc2fDA&ixlib=rb-4.1.0&q=85",
  hvac: "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxIVkFDJTIwdGVjaG5pY2FsJTIwaW5zdGFsbGF0aW9uJTIwZW5naW5lZXJpbmd8ZW58MHx8fHwxNzgzOTMxNTc3fDA&ixlib=rb-4.1.0&q=85",
  meeting: "https://images.unsplash.com/photo-1608303588026-884930af2559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3RzJTIwbWVldGluZyUyMHJldmlld2luZyUyMHBsYW5zfGVufDB8fHx8MTc4MzkzMTU3N3ww&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Over ons", to: "/over-ons" },
  { label: "Diensten", to: "/diensten" },
  { label: "Contact", to: "/contact" },
];

export const VALUES = [
  "Overzicht", "Vertrouwen", "Resultaat", "Kwaliteit", "Vakmanschap", "Transparantie",
];

export const SERVICES = [
  { icon: ClipboardText, title: "Projectmanagement", slug: "projectmanagement",
    desc: "Volledige regie op scope, planning, budget en kwaliteit — van initiatief tot oplevering.",
    benefits: ["Grip op planning en budget", "Heldere rapportages", "Risicobeheersing"] },
  { icon: Compass, title: "Projectleiding", slug: "projectleiding",
    desc: "Dagelijkse aansturing op de bouwplaats met één vast, betrokken aanspreekpunt.",
    benefits: ["Aansturing uitvoerende partijen", "Korte lijnen", "Kwaliteitscontrole"] },
  { icon: Hammer, title: "Renovatie", slug: "renovatie",
    desc: "Renovatie- en verduurzamingstrajecten binnen bewoonde en gebruikte omgevingen.",
    benefits: ["Minimale overlast", "Fasering op maat", "Duurzame resultaten"] },
  { icon: Wrench, title: "Onderhoud", slug: "onderhoud",
    desc: "Planmatig en correctief onderhoud dat vastgoed toekomstbestendig houdt.",
    benefits: ["Meerjarenonderhoudsplan", "Kostenbeheersing", "Continuïteit"] },
  { icon: Gear, title: "Werktuigbouwkunde", slug: "werktuigbouwkunde",
    desc: "Technische installaties, klimaat en energie — ontworpen, begeleid en beheerst.",
    benefits: ["Installatieadvies", "Energieoptimalisatie", "Technische keuringen"] },
  { icon: HeartStraight, title: "Zorgvastgoed", slug: "zorgvastgoed",
    desc: "Specialistische begeleiding van vastgoedopgaven binnen de zorgsector.",
    benefits: ["Zorg blijft doorlopen", "Kennis van regelgeving", "Comfort voor bewoners"] },
];

export const USPS = [
  { icon: ChatCircleText, title: "Heldere communicatie",
    desc: "Duidelijke afspraken en transparante rapportages, zodat u altijd weet waar u aan toe bent." },
  { icon: UserFocus, title: "Eén vast aanspreekpunt",
    desc: "Korte lijnen en persoonlijke betrokkenheid van begin tot eind van uw project." },
  { icon: Ruler, title: "Technische expertise",
    desc: "Diepgaande kennis van bouw, installaties en werktuigbouwkunde binnen complexe omgevingen." },
  { icon: ChartLineUp, title: "Planning en budget in controle",
    desc: "Strakke beheersing van tijd, geld en kwaliteit — met resultaat als uitgangspunt." },
];

export const PROCESS = [
  { icon: Handshake, step: "01", title: "Kennismaking", desc: "We verkennen uw opgave, ambities en randvoorwaarden." },
  { icon: MagnifyingGlass, step: "02", title: "Analyse", desc: "Grondige analyse van scope, techniek, risico's en budget." },
  { icon: PencilRuler, step: "03", title: "Planvorming", desc: "Een helder plan van aanpak met planning en beheersstructuur." },
  { icon: Hammer, step: "04", title: "Uitvoering", desc: "Dagelijkse regie, kwaliteitscontrole en voortgangsbewaking." },
  { icon: SealCheck, step: "05", title: "Oplevering", desc: "Zorgvuldige oplevering, nazorg en overdracht." },
];

export const CLIENTS = [
  "Zorggroep Noord", "Stedelijk Vastgoed", "De Zorgpartner", "Woonstichting Kern",
  "InstallTech BV", "Vastgoed Beheer NL", "Zorgcentrum Linde", "Bouwgroep Meridiaan",
];

export const CATEGORIES = ["Alle", "Renovatie", "Onderhoud", "Zorg", "Woningbouw", "Utiliteit"];

export const PROJECTS = [
  { slug: "zorgcentrum-de-linde", name: "Zorgcentrum De Linde", category: "Zorg",
    location: "Eindhoven", image: IMG.hero,
    short: "Grootschalige renovatie van een verpleeghuis met behoud van zorgcontinuïteit.",
    goal: "Verouderd zorgvastgoed verduurzamen en moderniseren terwijl bewoners op locatie blijven.",
    approach: "Gefaseerde renovatie per vleugel, strakke logistiek en dagelijkse afstemming met zorgteams.",
    result: "Een fris, energiezuinig en toekomstbestendig gebouw — opgeleverd binnen budget en planning.",
    meta: { klant: "Zorggroep Noord", jaar: "2024", rol: "Projectmanagement & Directievoering" },
    gallery: [IMG.hero, IMG.meeting, IMG.hvac] },
  { slug: "residentie-parkzicht", name: "Residentie Parkzicht", category: "Woningbouw",
    location: "Den Bosch", image: IMG.apartment,
    short: "Nieuwbouw appartementencomplex met 48 woningen en parkeerkelder.",
    goal: "Realisatie van een hoogwaardig woongebouw met strakke architectuur.",
    approach: "Integrale projectleiding vanaf ontwerp tot oplevering, met sturing op kwaliteit en budget.",
    result: "48 woningen opgeleverd met hoge afwerkkwaliteit en tevreden bewoners.",
    meta: { klant: "Stedelijk Vastgoed", jaar: "2023", rol: "Projectleiding" },
    gallery: [IMG.apartment, IMG.construction, IMG.meeting] },
  { slug: "installatietechniek-medisch-centrum", name: "Medisch Centrum — Klimaatinstallatie", category: "Utiliteit",
    location: "Tilburg", image: IMG.hvac,
    short: "Vervanging van klimaat- en luchtbehandelingsinstallaties in een medisch centrum.",
    goal: "Betrouwbaar binnenklimaat en fors lagere energiekosten.",
    approach: "Werktuigbouwkundige begeleiding, fasering rond openingstijden en strakke keuringen.",
    result: "Nieuw klimaatsysteem met 30% lager energieverbruik en verbeterd comfort.",
    meta: { klant: "InstallTech BV", jaar: "2024", rol: "Werktuigbouwkunde" },
    gallery: [IMG.hvac, IMG.construction, IMG.hero] },
  { slug: "verduurzaming-woonwijk", name: "Verduurzaming Woonwijk Kern", category: "Renovatie",
    location: "Oss", image: IMG.construction,
    short: "Verduurzaming van 120 huurwoningen in bewoonde staat.",
    goal: "Woningen naar een beter energielabel brengen met minimale overlast.",
    approach: "Strakke bewonerscommunicatie, planmatige uitvoering en kwaliteitsborging.",
    result: "120 woningen verduurzaamd, hogere woontevredenheid en lagere woonlasten.",
    meta: { klant: "Woonstichting Kern", jaar: "2023", rol: "Projectmanagement" },
    gallery: [IMG.construction, IMG.apartment, IMG.meeting] },
  { slug: "meerjarenonderhoud-zorgportefeuille", name: "Meerjarenonderhoud Zorgportefeuille", category: "Onderhoud",
    location: "Regio Brabant", image: IMG.meeting,
    short: "Opzet en regie van planmatig onderhoud voor een zorgvastgoedportefeuille.",
    goal: "Grip krijgen op onderhoudskosten en gebouwkwaliteit over meerdere locaties.",
    approach: "Inspecties, meerjarenonderhoudsplannen en centrale regie op uitvoering.",
    result: "Voorspelbare kosten, beheerste risico's en gebouwen in optimale conditie.",
    meta: { klant: "De Zorgpartner", jaar: "2022–heden", rol: "Onderhoudsregie" },
    gallery: [IMG.meeting, IMG.hero, IMG.hvac] },
  { slug: "renovatie-kantoorgebouw", name: "Renovatie Kantoorgebouw Meridiaan", category: "Utiliteit",
    location: "Breda", image: IMG.apartment,
    short: "Volledige renovatie en herinrichting van een kantoorgebouw.",
    goal: "Een verouderd kantoor transformeren naar een moderne, duurzame werkomgeving.",
    approach: "Integrale projectleiding met sturing op techniek, afwerking en planning.",
    result: "Een eigentijds, energiezuinig kantoor dat klaar is voor de toekomst.",
    meta: { klant: "Bouwgroep Meridiaan", jaar: "2023", rol: "Projectleiding & WTB" },
    gallery: [IMG.apartment, IMG.hvac, IMG.construction] },
];

export const CONTACT = {
  address: "Toon Bolsiusstraat 55, 5482 LB Schijndel",
  phone: "+31 6 36 17 61 69",
  email: "info@ballk.nl",
  linkedin: "https://www.linkedin.com/in/jeroenvanballekom/",
  maps: "https://www.google.com/maps?q=Toon+Bolsiusstraat+55,+5482+LB+Schijndel&output=embed",
};
